import {TIconsType} from "./graph-kn.cm-api-models"

interface iconData {
    path: string,
    scale?: { x: number, y: number },
    offsetY?: number
}
export const Icon_Base_Size = 14;
export const ICON_SCALE_BASE = 1
export const ICON_GAP_BASE = 2
export const KN_ICONS_MAP: Map<TIconsType, iconData> = new Map([
    ['ADD_INFO', {path: '../../../../assets/images/icons/three-dots.svg'}
    ],
    ['ADD_NODE', {path: '../../../../assets/images/icons/plus-circle-fill.svg'}],
    ['ADD_NODE_STEP', {path: '../../../../assets/images/icons/arrow-right-square-fill.svg'}],
    ['ADD_EDGE', {path: '../../../../assets/images/icons/plugin.svg'}],
    ['COMPLETED_STEP', {
        path: '../../../../assets/images/icons/check2-all.svg',
        scale: {x: 2, y: 2},
        offsetY: -1
    }],
    ['COMPLETED_TARGET', {
        path: '../../../../assets/images/icons/check2.svg',
        scale: {x: 2, y: 2},
        offsetY: -1
    }],
    ['ACTIVE_STEP', {
        path: '../../../../assets/images/icons/pen.svg',
        scale: {x: 1.3, y: 1.3},
        offsetY: -5
    }],
    ['CLOSE_ICON', {
        path: '../../../../assets/images/icons/x-circle-fill.svg',
        scale: {x: 1.5, y: 1.5},
        offsetY: 10
    }],
    ['is_archive', {path: '../../../../assets/icons/archive-fill.svg'}],
    ['is_finish', {path: '../../../../assets/icons/flag-fill.svg'}],
    ['is_initial', {path: '../../../../assets/icons/arrow-right-double-line.svg'}],
    ['is_successful', {path: '../../../../assets/icons/bookmark-3-fill.svg'}],
    ['is_universal', {path: '../../../../assets/icons/accessibility-line.svg'}],
    ['to_archive', {path: '../../../../assets/icons/archive-stack-fill.svg'}],
    ['attachments_files', {path: '../../../../assets/icons/attachment-2.svg'}],
    ['attachments_images', {path: '../../../../assets/icons/image-circle-ai-fill.svg'}],
])
export const KN_ICONS_WIDTH_RATIO: Map<TIconsType, number> = new Map([
    ['attachments_files', 0.7],
]) 